// extracted by mini-css-extract-plugin
export default {"container":"riOBc9kmo1CCmwyqjE81__container___"};